import Import from './Import/Import';
import Export from './Export/Export';
import './tools.scss';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppDate from './AppDate/AppDate';
import { elementNotVisibleOnEnv } from 'utils';
import PacageExclusion from './PacageExclusion/PacageExclusion';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const Tools = () => {
  const [value, setValue] = useState<number>(0);
  const { t } = useTranslation();
  const env = process.env.REACT_APP_ENV;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  const showDateTab = !elementNotVisibleOnEnv.includes(env as string);

  return (
    <div className="wrapper-inputs">
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label={t('tab.importExport')} {...a11yProps(0)} />
        {showDateTab && <Tab label={t('tab.dateSettings')} {...a11yProps(1)} />}
        <Tab label={t('tab.exploitationCode')} {...a11yProps(showDateTab ? 2 : 1)} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <Export />
        <Import />
      </CustomTabPanel>
      {showDateTab && (
        <CustomTabPanel value={value} index={1}>
          <AppDate />
        </CustomTabPanel>
      )}
      <CustomTabPanel value={value} index={showDateTab ? 2 : 1}>
        <PacageExclusion />
      </CustomTabPanel>
    </div>
  );
};

export default Tools;
